import ucfirst from 'ucfirst';
import { dialogAlert } from '../components/elements/Dialog/dialogs';

// TODO: replace this with proper messages from translation files

/**
 * Handles errors when the API returns the message
 * @param {object}      error           Error object from axios
 * @param {string}      defaultMessage  Alt message if nothing is returned from API
 * @param {function}    callback        What to call after
 */
export async function handleAPIProvidedErrorMessage(error, defaultMessage, callback) {
    const errorMessage = error.response?.data?.error_message;
    if (errorMessage) {
        await dialogAlert(ucfirst(errorMessage));
    } else if (defaultMessage) {
        await dialogAlert(defaultMessage);
    }
    if (callback) callback();
}
